import { bootstrap } from "./bootstrap.js";

function ready(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    callback();
  }
}

ready(() => {
  void bootstrap();
});
